import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import * as turf from '@turf/turf';

import { makeStyles } from '@material-ui/styles';
import { Box, Grid, Typography } from '@material-ui/core';

import { LengthText } from '../../../Common/UI/LengthText';
import { AreaText } from '../../../Common/UI/AreaText';
import { VolumeText } from '../../../Common/UI/VolumeText';

const propTypes = {
    feature: PropTypes.shape({
        geometry: PropTypes.object.isRequired,
        properties: PropTypes.shape({
            radius: PropTypes.number,
            height: PropTypes.number
        }).isRequired
    }).isRequired
};

const defaultProps = {

};

const useStyles = makeStyles((theme) => styles(theme));

function PolygonFeatureProperties ({ feature }) {
    const classes = useStyles();
    const area = turf.area(feature.geometry);
    return (
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <div className={classes.row}>
                    <Typography
                        variant="caption"
                        color="textPrimary"
                    >
                        {feature.properties.height ? 'Footprint' : 'Area'}:
                    </Typography>
                    <Typography
                        variant="caption"
                        color="textPrimary"
                    >
                        <AreaText area={area} unit="ha" /> <br />
                        <AreaText area={area} unit="ac" /> <br />
                        <AreaText area={area} unit="m2" />
                    </Typography>
                </div>
            </Grid>
            <Grid item xs={6}>
                {Boolean(feature.properties.radius) && <div className={`${classes.row} ${classes.alignItemsCenter}`}>
                    <Typography
                        variant="caption"
                        color="textPrimary"
                        component="div"
                    >
                        Radius:
                    </Typography>
                    <Typography
                        variant="caption"
                        color="textPrimary"
                        component="div"
                    >
                        <LengthText length={feature.properties.radius} />
                    </Typography>
                </div>}
                {feature.properties.height && <div className={`${classes.row} ${classes.alignItemsCenter}`}>
                    <Typography
                        variant="caption"
                        color="textPrimary"
                        component="div"
                    >
                        Height:
                    </Typography>
                    <Typography
                        variant="caption"
                        color="textPrimary"
                        component="div"
                    >
                        <LengthText length={feature.properties.height} />
                    </Typography>
                </div>}
                {feature.properties.height && <div className={classes.row}>
                    <Typography
                        variant="caption"
                        color="textPrimary"
                    >
                        Volume:
                    </Typography>

                    <Typography
                        variant="caption"
                        color="textPrimary"
                    >
                        <VolumeText volume={area * feature.properties.height} />
                    </Typography>
                </div>}
            </Grid>
        </Grid>
    );
}

const styles = (theme) => ({
    row: {
        display: 'flex',
        // justifyContent: 'space-between',
        // maxWidth: 200
        '&> *:first-child': {
            minWidth: 75,
        }
    },
    alignItemsCenter: {
        alignItems: 'center'
    }
});

PolygonFeatureProperties.propTypes = propTypes;
PolygonFeatureProperties.defaultProps = defaultProps;

export default PolygonFeatureProperties;